import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Smartphone, Apple, PlayCircle, Zap, CheckCircle } from 'lucide-react';

const MobileApps = () => {
  const { t } = useTranslation();
  const sp = (key) => t(`service_pages.mobile_apps.${key}`);
  const common = (key) => t(`service_pages.common.${key}`);

  const features = [
    sp('features.f1'),
    sp('features.f2'),
    sp('features.f3'),
    sp('features.f4'),
    sp('features.f5'),
    sp('features.f6'),
    sp('features.f7'),
    sp('features.f8'),
    sp('features.f9'),
    sp('features.f10'),
    sp('features.f11'),
    sp('features.f12')
  ];

  return (
    <>
      <Helmet>
        <title>{sp('meta_title')}</title>
        <meta name="description" content={sp('meta_desc')} />
        <meta name="keywords" content="Thailand app development, Pattaya mobile apps, Android development Thailand, iOS app Pattaya, Flutter developer Thailand" />
        <link rel="canonical" href="https://karnidigitalsolutions.com/services/mobile-apps" />
      </Helmet>

      <section className="pt-24 pb-16 bg-gradient-primary text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6" data-aos="fade-up">
              {sp('title')}
            </h1>
            <p className="text-xl md:text-2xl text-gold mb-8 max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="200">
              {sp('subtitle')}
            </p>
            <div className="flex flex-wrap gap-4 justify-center" data-aos="fade-up" data-aos-delay="400">
              <Link to="/contact" className="btn-gold">{common('get_quote')}</Link>
              <a href="https://wa.me/66968826252" className="btn-primary" target="_blank" rel="noopener noreferrer">
                {common('whatsapp_us')}
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-12 text-center">
            {sp('section_title')}
          </h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start space-x-3" data-aos="fade-up" data-aos-delay={index * 50}>
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
                <span className="text-gray-700 font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8">
            <div className="card bg-white text-center" data-aos="fade-up">
              <Apple className="w-16 h-16 text-primary mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-primary mb-2">iOS Development</h3>
              <p className="text-gray-600">Swift & Objective-C apps for iPhone & iPad</p>
            </div>
            
            <div className="card bg-white text-center" data-aos="fade-up" data-aos-delay="100">
              <PlayCircle className="w-16 h-16 text-primary mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-primary mb-2">Android Development</h3>
              <p className="text-gray-600">Kotlin & Java apps for all Android devices</p>
            </div>
            
            <div className="card bg-white text-center" data-aos="fade-up" data-aos-delay="200">
              <Zap className="w-16 h-16 text-primary mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-primary mb-2">Cross-Platform</h3>
              <p className="text-gray-600">Flutter & React Native for both platforms</p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gradient-gold">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <Smartphone className="w-16 h-16 text-primary mx-auto mb-6" />
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            {sp('cta_title')}
          </h2>
          <p className="text-xl text-primary-700 mb-8">
            {sp('cta_desc')}
          </p>
          <Link to="/contact" className="btn-primary">{common('request_quote')}</Link>
        </div>
      </section>
    </>
  );
};

export default MobileApps;
